import { Locale } from '@/locales'

export type Language = {
  language_code: Locale
  language: string
  display: string
}

export const SUPPORTER_LANGUAGES: Language[] = [
  // {
  //   language_code: 'ar',
  //   language: 'Arabic',
  //   display: 'العربية',
  // },
  {
    language_code: 'cs',
    language: 'Czech',
    display: 'Čeština',
  },
  {
    language_code: 'da',
    language: 'Danish',
    display: 'Dansk',
  },
  {
    language_code: 'de',
    language: 'German',
    display: 'Deutsch',
  },
  {
    language_code: 'en',
    language: 'English',
    display: 'English',
  },
  {
    language_code: 'es',
    language: 'Spanish',
    display: 'Español',
  },
  {
    language_code: 'fi',
    language: 'Finnish',
    display: 'Suomi',
  },
  {
    language_code: 'fil',
    language: 'Filipino',
    display: 'Filipino',
  },
  {
    language_code: 'fr',
    language: 'French',
    display: 'Français',
  },
  {
    language_code: 'hu',
    language: 'Hungarian',
    display: 'Magyar',
  },
  {
    language_code: 'id',
    language: 'Indonesian',
    display: 'Bahasa Indonesia',
  },
  {
    language_code: 'it',
    language: 'Italian',
    display: 'Italiano',
  },
  {
    language_code: 'ja',
    language: 'Japanese',
    display: '日本語',
  },
  {
    language_code: 'ko',
    language: 'Korean',
    display: '한국어',
  },
  {
    language_code: 'ms',
    language: 'Malay',
    display: 'Bahasa Melayu',
  },
  {
    language_code: 'nl',
    language: 'Dutch',
    display: 'Nederlands',
  },
  {
    language_code: 'no',
    language: 'Norwegian',
    display: 'Norsk Bokmål',
  },
  {
    language_code: 'pl',
    language: 'Polish',
    display: 'Polski',
  },
  {
    language_code: 'pt',
    language: 'Portuguese',
    display: 'Português',
  },
  {
    language_code: 'pt-br',
    language: 'BrazilianPortuguese',
    display: 'Português (Brasil)',
  },
  {
    language_code: 'ro',
    language: 'Romanian',
    display: 'Română',
  },
  {
    language_code: 'ru',
    language: 'Russian',
    display: 'Русский',
  },
  {
    language_code: 'sv',
    language: 'Swedish',
    display: 'Svenska',
  },
  {
    language_code: 'th',
    language: 'Thai',
    display: 'ภาษาไทย',
  },
  {
    language_code: 'tr',
    language: 'Turkish',
    display: 'Türkçe',
  },
  {
    language_code: 'vi',
    language: 'Vietnamese',
    display: 'Tiếng Việt',
  },
  {
    language_code: 'zh-tw',
    language: 'TraditionalChinese',
    display: '繁體中文',
  },
]
export const SUPPORTER_LOCALES: Locale[] = SUPPORTER_LANGUAGES.map(
  (lang) => lang.language_code
)
export const DEFAULT_LOCALE = 'en'
